import React from 'react';
import { styles, colors } from '../../styles/styles';

/**
 * Search icon component used within the search input
 */
const SearchIcon = ({ style, color = colors.textSecondary, size = 16 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path 
        d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z" 
        stroke={color} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round" 
      />
    </svg>
  );
};

/**
 * Reusable search input component used throughout the app
 * Provides a consistent search experience with proper styling
 */
const SearchInput = ({ 
  value, 
  onChange, 
  placeholder = "Search...", 
  containerStyle, 
  inputStyle,
  type = "desktop" // 'desktop' or 'mobile'
}) => {
  // Determine which styles to use based on type
  const containerStyleToUse = type === 'desktop' 
    ? styles.desktopSearchInput.container 
    : styles.mobileSearchInput.container;
    
  const iconStyleToUse = type === 'desktop'
    ? styles.desktopSearchInput.icon
    : styles.mobileSearchInput.icon;
    
  const inputStyleToUse = type === 'desktop'
    ? styles.desktopSearchInput.input
    : styles.mobileSearchInput.input;
    
  // Use larger icon for mobile
  const iconSize = type === 'desktop' ? 16 : 20;

  return (
    <div style={{...containerStyleToUse, ...containerStyle}}>
      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={{
          ...styles.input,
          ...inputStyleToUse,
          ...inputStyle
        }}
      />
      <SearchIcon style={iconStyleToUse} size={iconSize} />
    </div>
  );
};

export default SearchInput; 